import { CommentsSection } from '@opportunities/-components/CommentsSection'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useRef } from 'react'
import { queryKeys } from '@/lib/queryKeys'

interface CommentsTabProps {
  opportunityId: number
  editable: boolean
}
/**
 * コメント一覧タブコンポーネント
 *
 * オポチュニティのコメント一覧を表示・作成・編集・削除するタブ
 */
export function CommentsTab({ opportunityId, editable }: CommentsTabProps) {
  const queryClient = useQueryClient()
  const hasMarkedAsRead = useRef(false)

  // コメント一覧が初回取得された時にcomment-markersのキャッシュを無効化してバッジを更新
  const handleCommentsLoaded = useCallback(() => {
    if (!hasMarkedAsRead.current) {
      hasMarkedAsRead.current = true
      queryClient.invalidateQueries({
        queryKey: queryKeys.opportunity.commentMarkers(opportunityId),
      })
    }
  }, [opportunityId, queryClient])

  return <CommentsSection opportunityId={opportunityId} editable={editable} onCommentsLoaded={handleCommentsLoaded} />
}
